import { STATS_CONFIG } from '../../constants';
import { useCountUp } from '../../hooks/useCountUp';
import { useLanguage } from '../../hooks/useLanguage';
import '../../styles/components/Stats.css';

const StatItem = ({ stat, label }) => {
  const { count, elementRef } = useCountUp(stat.value);

  return (
    <div className='stat-item' ref={elementRef}>
      <span className='stat-number'>
        {count}
        {stat.suffix}
      </span>
      <div className='stat-accent-line' />
      <span className='stat-label'>{label}</span>
    </div>
  );
};

const Stats = () => {
  const { t } = useLanguage();

  return (
    <section id='stats' className='stats section'>
      <div className='container'>
        <p className='stats-motto'>{t.stats.motto}</p>
        <div className='stats-grid'>
          {STATS_CONFIG.map(stat => (
            <StatItem
              key={stat.id}
              stat={stat}
              label={t.stats.items[stat.id]}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
